module.exports = __webpack_public_path__ + "static/media/banner1b.79514222.svg";